import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import config from './data/config.json';
import Slider from 'react-slick';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './OurServices.css';
import IconComponent from './IconComponent';

const OurServices = () => {
  const sliderRef = useRef<any>(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // State to track the tallest card
  const [tallestCardHeight, setTallestCardHeight] = useState<number>(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (index: number) => setCurrentSlide(index),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, arrows: true },
      },
    ],
  };

  const handleNext = () => sliderRef.current?.slickNext();
  const handlePrev = () => sliderRef.current?.slickPrev();

  // Track the tallest card height on mount and when the window resizes
  useEffect(() => {
    const updateTallestCardHeight = () => {
      if (window.innerWidth < 768) {
        // On mobile, skip the height equalization
        setTallestCardHeight(0);
        return;
      }

      const cardElements = document.querySelectorAll('.card');
      let maxHeight = 0;

      cardElements.forEach((card: any) => {
        const cardHeight = card.offsetHeight;
        if (cardHeight > maxHeight) {
          maxHeight = cardHeight;
        }
      });

      setTallestCardHeight(maxHeight);
    };

    updateTallestCardHeight();

    window.addEventListener('resize', updateTallestCardHeight);
    return () => window.removeEventListener('resize', updateTallestCardHeight);
  }, [config.services]);

  return (
    <div className="our-services position-relative">
      <div className="container py-5 position-relative">
        <h2 className="text-center mb-4">Our Services</h2>
        <p className="col-12 col-md-6 mx-auto text-center mb-4">
          We offer a wide range of cleaning services, as well as maid services and housekeeping
          services, to meet your specific needs
        </p>

        <div className="slider-wrapper position-relative">
          <Slider ref={sliderRef} {...settings}>
            {config.services.map((service, index) => (
              <div key={index} className="p-3 slide-item">
                <div
                  className="card shadow-sm border-0 rounded-4"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: tallestCardHeight ? `${tallestCardHeight}px` : 'auto',
                  }}
                >
                  <img
                    src={service.img}
                    alt={service.title}
                    className="card-img-top rounded-top-4"
                    style={{ objectFit: 'cover', height: '200px' }}
                  />
                  <div className="card-body d-flex flex-column" style={{ flexGrow: 1 }}>
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text small">{service.description}</p>
                    <Link to={service.url} className="btn btn-green mt-3 align-self-start w-100">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
